import { put, takeLatest, retry, call } from '@redux-saga/core/effects';
import {
	fetchInspectionOverview,
	fetchInspectionOverviewResolved,
	fetchInspectionOverviewRejected,
	fetchInspectionStandardCodes,
	fetchInspectionStandardCodesResolved,
	fetchInspectionStandardCodesRejected,
} from '@Actions/inspections.actions';
import { fetchInspectionsOverview, fetchInspectionStandardCodesAPI } from '@Services/inspections.services';
import { DefectCode, InspectionType } from '@Types/inspections.types';

export function* fetchInspectionOverviewSaga() {
	try {
		const response: InspectionType[] = yield retry(5, 10000, fetchInspectionsOverview);
		yield put(fetchInspectionOverviewResolved(response));
	} catch (err) {
		const message = err instanceof Error ? err.message || 'Unknown error' : 'Unknown error';
		yield put(fetchInspectionOverviewRejected([message]));
	}
}

function* watchFetchInspectionOverviewSaga() {
	yield takeLatest(fetchInspectionOverview, fetchInspectionOverviewSaga);
}

export function* fetchInspectionStandardCodesSaga(action: ReturnType<typeof fetchInspectionStandardCodes>) {
	const standard = action.payload;

	try {
		const codes: DefectCode[] = yield call(fetchInspectionStandardCodesAPI, standard);
		yield put(fetchInspectionStandardCodesResolved({ standard, codes }));
	} catch (error) {
		const message = error instanceof Error ? error.message : 'Unknown error';
		yield put(
			fetchInspectionStandardCodesRejected({
				standard,
				error: message,
			}),
		);
	}
}

function* watchFetchInspectionStandardCodesSaga() {
	yield takeLatest(fetchInspectionStandardCodes, fetchInspectionStandardCodesSaga);
}

const sagaArray = [watchFetchInspectionOverviewSaga(), watchFetchInspectionStandardCodesSaga()];
export default sagaArray;
